import ManageGroupTraps from './ManageGroupTraps'
import enhance from './ManageGroupTraps.enhancer'

export default enhance(ManageGroupTraps)

export const manageGroupTrapsColumns = [
  {
    width: 30, field: 'selectable', selectable: true, format: 'locate',
  },
  {
    width: 500, label: 'Trap Name', field: 'trapName', format: 'trapName'
  },
  {
    width: 200, 
    field: 'select', 
    selectable: true, 
    hideHeader: true,
    align: 'flex-end',
    format: 'expandBox',
    selectableLabel: 'Remove from group'
  }
]



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupTraps/index.js